import React, { useState } from "react";
import {
  Box,
  Modal,
  Button,
  Typography,
  LinearProgress,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../../constants/site-content";

interface ImageInfo {
  url: string;
  text: string;
}
interface TutorialModalProps {
  open: boolean;
  images: ImageInfo[];
  onClose: () => void;
}

const buttonStyle = {
  fontSize: "18px",
  color: colors.brandColor,
  fontWeight: "bold",
};
const TutorialModal: React.FC<TutorialModalProps> = ({
  open,
  images,
  onClose,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = images.length;

  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      setCurrentStep(0);
      onClose();
    }
  };

  const progress = Math.round(((currentStep + 1) / totalSteps) * 100);

  return (
    <Modal
      open={open}
      aria-labelledby="tutorial-modal-title"
      aria-describedby="tutorial-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClose={(_event, reason) => {
        if (reason !== "backdropClick") {
          setCurrentStep(0);
          onClose();
        }
      }}
    >
      <Box
        sx={{
          width: "50%",
          maxWidth: "600px",
          height: "80vh",
          maxHeight: "700px",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 2,
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => {
            setCurrentStep(0);
            onClose();
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="tutorial-modal-title" variant="h6" component="h2">
          Tip {currentStep + 1} of {totalSteps}
        </Typography>
        <Box
          component="img"
          src={images[currentStep].url}
          sx={{
            width: "100%",
            height: "70%",
            aspectRatio: "1/1",
            alignSelf: "center",
            my: 2,
            objectFit: "contain",
          }}
        />
        <Typography
          variant="body2"
          sx={{ textAlign: "center", fontSize: "18px" }}
        >
          {images[currentStep].text}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{ width: "100%", my: 1 }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "15px",
          }}
        >
          <Button
            sx={buttonStyle}
            onClick={() => {
              setCurrentStep(0);
              onClose();
            }}
          >
            Skip Tutorial
          </Button>
          <Button sx={buttonStyle} onClick={handleNext}>
            {currentStep < totalSteps - 1 ? "Next Tip" : "Finalize"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TutorialModal;
